import CircleIcon from '@mui/icons-material/Circle'
import { Menu, Tooltip, Typography, Zoom, styled } from '@mui/material'
import dayjs from 'dayjs'
import { MRT_Cell } from 'material-react-table'

import { contentMessages, dateFormat } from 'utils/constants/ui'

export const filterList = [
  {
    title: 'Status',
    options: [
      { label: 'Active', value: true, field: 'isActive' },
      { label: 'Inactive', value: false, field: 'isActive' },
    ],
  },
  {
    title: 'Coupon type',
    options: [
      { label: 'Unique', value: true, field: 'isUniqueCoupon' },
      {
        label: 'System applied',
        value: true,
        field: 'isSystemApplied',
      },
      {
        label: 'Generic',
        value: false,
        field: 'isUniqueCoupon',
      },
    ],
  },
]

export const MenuStyle = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '13.5rem',
    borderRadius: theme.shape.borderRadius,
    '.MuiMenuItem-root': {
      padding: theme.spacing(1.25, 2),
      '&:not(:last-child)': {
        borderBottom: `2px solid ${theme.palette.grey[300]}`,
      },
      '.MuiTypography-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
      },
    },
  },
}))

export const renderLastChanged = ({ cell }: { cell: MRT_Cell<any> }) => {
  const value = cell?.getValue() as string
  return (
    <Typography overflow="hidden" textOverflow="ellipsis" variant="body2">
      {dayjs(value).isValid()
        ? dayjs(value).format(dateFormat.dateFormatWithFullDate)
        : contentMessages.NO_DATA}
    </Typography>
  )
}

export const renderStatusCell = ({ cell }: { cell: MRT_Cell<any> }) => {
  const isActive = cell?.getValue() === 'ACTIVE' || cell?.getValue()

  return (
    <Tooltip
      title={isActive ? 'Active' : 'Inactive'}
      color="red"
      placement="right-end"
      arrow
      TransitionComponent={Zoom}
    >
      <CircleIcon
        color={isActive ? 'success' : 'error'}
        sx={{ width: '0.8rem', marginLeft: '0.5rem' }}
      />
    </Tooltip>
  )
}
